import { cva } from "cva";

export const headerMobileMenuFooterStyles = cva({
  base: "w-full p-lg",
});
